import React from "react";
import styled from "styled-components";
import { NotificationEntity } from "src/firebase/db/Notifications";
import { formatDate } from "src/helpers/UtilityHelper";
import StyleConfig from "src/constants/StyleConfig";
import ListTitle from "src/components/molecules/list/ListTitle";

interface Props {
  notification: NotificationEntity;
}

const NotificationTimeStampHeader = ({ ...props }: Props) => {
  const { notification } = props;
  return (
    <Header>
      <div className="times">
        <ListTitle
          title={`${formatDate(notification.scheduled_time, "HH:mm")} 配信${
            notification.is_notified ? "" : "予定"
          }`}
        />
        <div className="times-others">
          <p>
            <span>ラストオーダー</span>
            <span>{formatDate(notification.can_order_time, "HH:mm")}</span>
          </p>
          <p>
            <span>最終受取時刻</span>
            <span>{formatDate(notification.last_pickup_time, "HH:mm")}</span>
          </p>
        </div>
      </div>
    </Header>
  );
};

const Header = styled.header`
  .times {
    margin-bottom: 10px;

    h3 {
      margin-top: 14px !important;
      margin-bottom: 2px !important;
    }
    .times-others {
      width: 100%;
      display: inline-flex;

      p {
        &:first-child {
          margin-right: 12px;
        }

        span {
          &:first-child {
            color: ${StyleConfig.COLOR.TEXT_GRAY};
            margin-right: 8px;
          }
        }
      }
    }
  }
`;

export default NotificationTimeStampHeader;
